import _ from 'lodash'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { IncidentReport } from '../../../../components/reports'
import Operations from '../../../../operations'
import { withRouter } from '../../../../withRouter'

interface RouterParams {
  id: string
}

interface Router {
  params: RouterParams
}

interface HomeIncidentsProps {
  data?: any[]
  error?: any
  fetchData: (id: string) => void
  isLoading?: boolean
  router: Router
}

export function HomeIncidents(props: HomeIncidentsProps) {
  const {
    data,
    error,
    fetchData,
    isLoading,
    router: { params }
  } = props

  useEffect(() => {
    fetchData(params.id)
  }, [params.id])

  return (
    <div style={styles.reportContainer}>
      <IncidentReport
        title={'Incidents'}
        backLink={`/homes/${params.id}/dashboard`}
        data={data}
        isLoading={isLoading}
        error={error}
        emptyText={'This site has no Incidents to display.'}
        chartHeight={400}
      />
    </div>
  )
}

const styles = {
  reportContainer: {
    margin: '0 auto',
    maxWidth: 960,
    padding: '30px 0px 80px 0px',
    position: 'relative' as const
  }
}

const STATE_ID = 'home_incidents'

const mapStateToProps = (state: any) => {
  return {
    data: _.get(state, `data.requests.${STATE_ID}.response`),
    isLoading: _.get(state, `data.requests.${STATE_ID}.isLoading`),
    error: _.get(state, `data.requests.${STATE_ID}.error`)
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    fetchData: (id: string) => {
      dispatch(
        Operations.fetchData({
          url: 'aggregations/incidents',
          query: { home: id },
          id: STATE_ID
        })
      )
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HomeIncidents))
